import React, {useEffect,useRef, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import Avatar from '@material-ui/core/Avatar';
import Fab from '@material-ui/core/Fab';
import SendIcon from '@material-ui/icons/Send';
import {deleteChats, getChats,getLiveChat} from "../../repo/chatsRepo";
import { Loading } from "../templates/Loading";
import { compareAsc, format } from 'date-fns';
import { DatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { Container} from '@material-ui/core';
import LogoPrivategpt from '../../img/logo-privategpt.svg';
import LoaderBrain from '../../img/LoderBrain.gif';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import {OutlinedInput,InputLabel, MenuItem,Button, IconButton, Tooltip ,FormControl,Select, FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import history from './../../history';
import dayjs from 'dayjs';
const useStyles = makeStyles({
  button: {  
    height:'42px',  
    textTransform:'capitalize',
    backgroundColor:'#334155',
    color:'#fff',
    '&:hover': {
      backgroundColor: '#25364f!important',
    },    
  }, 
  table: {
    minWidth: 650,
  },
  chatSection: {
    width: '100%',
    //height: '65vh',

  },
  dateTimeText: {
    fontSize:'8px',
  },
  headBG: {
      backgroundColor: '#e0e0e0'
  },
  borderRight500: {
      borderRight: '1px solid #e0e0e0'
  },
  messageArea: {
    height: 'calc(100vh - 245px)',    
    paddingLeft: '25px',
    paddingRight: '25px',
    scrollbarWidth: 'thin', // For Firefox
    overflowX: 'hidden',
    overflowY: 'auto', // Ensure the container has a scrollbar
    '&::-webkit-scrollbar': {
      width: '6px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#888',
      borderRadius: '5px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: '#555',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'linear-gradient(90deg, rgba(28,28,28,1) 0%, rgba(3,101,177,1) 35%, rgba(28,28,28,1) 100%)',
    },
    
   
  },
   textMessage: {
    alignItems: 'center',
    backgroundColor: '#cdd5f5',
    borderRadius: '15px 15px 0px 15px',
    boxSizing: 'border-box',
    display: 'flex',
    maxHeight: 'none',
    minHeight: '39px',
    padding: '10px 15px',
    position: 'relative',
	  justifyContent: 'end',
    width: 'fit-content',
    float: 'right',
  },
  textMessageLeft: {
    alignItems: 'center',
    backgroundColor: '#f1f3f4',
    borderRadius: '0px 15px 15px 15px',
    boxSizing: 'border-box',
    display: 'flex',
    maxHeight: 'none',
    minHeight: '48px',
    padding: '10px 17px',
    position: 'relative',
	  justifyContent: 'start',
    width: 'fit-content',
  },
  messContainer:{
    width:'auto',

  },
  messRoot:{
    justifyContent:'end',
  },
  chatHeading:{
    color:'white',
    textAlign: 'left',
    paddingLeft: '20px'
  },
  chatHeadingSec:{
    color:'white',
    textAlign: 'left',
    paddingLeft: '20px',
    fontSize:'16px',
    textDecoration: 'navajowhite',
  },

  chatHeadingSec1:{
    color:'white',
    textAlign: 'left',
    paddingLeft: '20px',
    fontSize:'16px',
    marginTop: '-20px',
    textDecoration: 'navajowhite',
    marginBottom: '-5px'
  },
  chatHeadingSec11:{
    color: 'white',
    fontSize: '16px',
    textAlign: 'left',
    paddingLeft: '3px',
    textDecoration: 'navajowhite',
    padding: '5px'
  },
 
  inputField:{
    height:'40px',
    backgroundColor: '#0F172A',
    padding:"0 0 0 24px",
    color:'#fff',
    fontSize:'12px',
    borderRadius:'6px',
    boxShadow: '0px 1px 2px 0px #0000000D',
    boxShadow: '0px 0px 0px 1px #334155 inset',
    boxShadow: '0px 0px 0px 0px #FFFFFF inset',
    border:'1px solid #334155',
    '& label':{
      color:'#334155',
      padding:"0 0 0 24px",
      
    },
    '&:focus legend span':{
      color:'#334155!important',
    },
    '&:hover fieldset': {
      borderColor: 'none!important',
    },
    '& .MuiInputBase-input': {
      color:'#fff',
      top: '-10px',
      position: 'relative'

    }
        
  }
});


const LiveChatUI = (props) => {
  const [loading, setLoading] = useState(false);
  const [messagetime, setMessagetime] = useState('');
  const [msg, setMsg] = useState('');
  const [messages, setMessages] = useState([]);
  const [selAgentId, setSelAgentId] = useState(1);
  const [agentData, setAgentdata] = useState([]);
  const [selectedOption, setSelectedOption] = useState(1);
  const [selBrainId, setSelBrainId] = useState('c2d7fbc6-3a53-4cc5-97b4-538f56bb48ea');
  const messageRef = useRef(null);
  //const inputRef = useRef(null);
  const [nextDate, setNextDate] = useState(dayjs(new Date()));
  
  
  
  useEffect(() => {          
    
    getLiveChatList();
    const agentData = [{"id":"1","name":"DATA Ingenious"},{"id":"2","name":"VideoMeet"},{"id":"3","name":"SemiDot Infotech"},{"id":"4","name":"Xgenplus"},{"id":"5","name":"Private AI GPT"},{"id":"8","name":"World Heritage India 2024"}];
    setAgentdata(agentData);
    
    
  }, []);
  
  const classes = useStyles();

    // Handler for selecting date
    const handleDateChange = (date) => {
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      setNextDate(`${month}/${day}/${year}`);
    };
  
    // Handler for search button click
    const handleSearch = async () => {
     
      const res = await getLiveChat(selectedOption,nextDate);
      setMessages(res.data);
     // const res = [{"id":"1061","question":"87897987897Which services company provide ?","answer":"Thank you for reaching out to us! At SemiDot Infotech, we specialize in providing comprehensive solutions for various industries, including home service and handyman businesses. Our expertise lies in designing and developing custom-made mobile apps that cater to the unique needs of your business.\n\nWe offer a wide range of services, including:\n\n1. On-demand home service app development: We create user-friendly apps that connect customers with local professionals, streamlining the booking process and enhancing overall customer experience.\n2. Customized UI\/UX design: Our team of experts will work closely with you to craft an intuitive and visually appealing interface that reflects your brand's identity.\n3. Integration with eWallet or digital wallet: We can integrate a secure payment gateway, allowing customers to make seamless transactions within the app.\n4. Admin panel management: Our solution includes a user-friendly admin panel for easy management of bookings, professionals, and customer data.\n\nIf you're interested in learning more about how we can help your home service business thrive, I'd be happy to set up a call or provide a personalized demo. Please feel free to reach out to me at sales@semidotinfotech.com or +917737970891 (WhatsApp). I look forward to discussing your project further!","status":"0","is_copied":"0","parsona_id":"3","ip_address":null,"browser_name":null,"created_at":"24 May 2024 11:05:07 AM"},{"id":"1060","question":"\u0915\u0902\u092a\u0928\u0940 \u0915\u0947 \u0928\u093f\u0926\u0947\u0936\u0915 \u0915\u094c\u0928 \u0939\u0948\u0902 ?","answer":"Namaste! I'm happy to help you with your query.\n\nSemidot Infotech is a leading software development company that specializes in creating innovative solutions for various industries, including job portals. Our team of experts has extensive experience in designing and developing custom-made applications that cater to the unique needs of our clients.\n\nRegarding your question about the cost to develop a job portal app like Naukri.com, I'd be happy to provide you with some insights. As per our expertise, the cost can vary depending on several factors such as the complexity of the features, the technology stack used, and the development time required.\n\nHowever, I can give you a rough estimate based on our previous projects. For instance, developing a job portal app with basic features like job posting, resume upload, and search functionality could start from around $10,000 to $20,000. On the other hand, if you're looking for more advanced features like AI-powered matching, video resumes, or integrations with popular HR tools, the cost could range from $50,000 to $100,000 or more.\n\nIf you're interested in learning more about our services and how we can help you create a job portal app that meets your specific needs, I'd be happy to set up a call with you. You can reach me at sales@semidotinfotech.com or +91-77379-70891 (WhatsApp).\n\nPlease let me know if you have any further questions or would like to discuss your project in more detail!","status":"0","is_copied":"0","parsona_id":"3","ip_address":null,"browser_name":null,"created_at":"24 May 2024 11:04:38 AM"}];
      //setMessages(res);
  
  
    };


  const getLiveChatList = async (EventVal,msgdata) => {
   // const res = [{"id":"1061","question":"Which services company provide ?","answer":"Thank you for reaching out to us! At SemiDot Infotech, we specialize in providing comprehensive solutions for various industries, including home service and handyman businesses. Our expertise lies in designing and developing custom-made mobile apps that cater to the unique needs of your business.\n\nWe offer a wide range of services, including:\n\n1. On-demand home service app development: We create user-friendly apps that connect customers with local professionals, streamlining the booking process and enhancing overall customer experience.\n2. Customized UI\/UX design: Our team of experts will work closely with you to craft an intuitive and visually appealing interface that reflects your brand's identity.\n3. Integration with eWallet or digital wallet: We can integrate a secure payment gateway, allowing customers to make seamless transactions within the app.\n4. Admin panel management: Our solution includes a user-friendly admin panel for easy management of bookings, professionals, and customer data.\n\nIf you're interested in learning more about how we can help your home service business thrive, I'd be happy to set up a call or provide a personalized demo. Please feel free to reach out to me at sales@semidotinfotech.com or +917737970891 (WhatsApp). I look forward to discussing your project further!","status":"0","is_copied":"0","parsona_id":"3","ip_address":null,"browser_name":null,"created_at":"24 May 2024 11:05:07 AM"},{"id":"1060","question":"\u0915\u0902\u092a\u0928\u0940 \u0915\u0947 \u0928\u093f\u0926\u0947\u0936\u0915 \u0915\u094c\u0928 \u0939\u0948\u0902 ?","answer":"Namaste! I'm happy to help you with your query.\n\nSemidot Infotech is a leading software development company that specializes in creating innovative solutions for various industries, including job portals. Our team of experts has extensive experience in designing and developing custom-made applications that cater to the unique needs of our clients.\n\nRegarding your question about the cost to develop a job portal app like Naukri.com, I'd be happy to provide you with some insights. As per our expertise, the cost can vary depending on several factors such as the complexity of the features, the technology stack used, and the development time required.\n\nHowever, I can give you a rough estimate based on our previous projects. For instance, developing a job portal app with basic features like job posting, resume upload, and search functionality could start from around $10,000 to $20,000. On the other hand, if you're looking for more advanced features like AI-powered matching, video resumes, or integrations with popular HR tools, the cost could range from $50,000 to $100,000 or more.\n\nIf you're interested in learning more about our services and how we can help you create a job portal app that meets your specific needs, I'd be happy to set up a call with you. You can reach me at sales@semidotinfotech.com or +91-77379-70891 (WhatsApp).\n\nPlease let me know if you have any further questions or would like to discuss your project in more detail!","status":"0","is_copied":"0","parsona_id":"3","ip_address":null,"browser_name":null,"created_at":"24 May 2024 11:04:38 AM"}];
    //setMessages(res);
    //const res = await getLiveChat();
    //setMessages(res.data);
    //console.log(res.data);
    //console.log("#############");
    //console.log(messages);
  };

  


  return (
    <div>
      
    
    <div className="livesearchheader chatInnerContainer">
     <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Grid container spacing={1}>
      <Grid item xs={12} md={3}>
      <div style={{alignItems:'center',display:'flex',margin:'0px 0 7px 18px'}}>
      <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none">
      <rect width="35" height="35" rx="17.5" fill="#ffffff"/>
      <path d="M17.4297 23L16.6016 20.2812H12.4375L11.6094 23H9L13.0312 11.5312H15.9922L20.0391 23H17.4297ZM16.0234 18.25L15.1953 15.5938C15.1432 15.4167 15.0729 15.1901 14.9844 14.9141C14.901 14.6328 14.8151 14.349 14.7266 14.0625C14.6432 13.7708 14.5755 13.5182 14.5234 13.3047C14.4714 13.5182 14.3984 13.7839 14.3047 14.1016C14.2161 14.4141 14.1302 14.7109 14.0469 14.9922C13.9635 15.2734 13.9036 15.474 13.8672 15.5938L13.0469 18.25H16.0234ZM21.4844 23V11.5781H23.9062V23H21.4844Z" fill="#36217C"/>
      </svg>
      <h4 className={classes.chatHeadingSec}><span style={{marginLeft:'-10px',marginRight:'10px'}}>Live Chat Listing</span></h4>
      </div>
      </Grid>
      <Grid item xs={12} md={3}>
       <FormControl fullWidth margin="normal" size="small">
          <InputLabel id="agentId-label">Select Agent</InputLabel>
          <Select style={{color:'white'}}
            labelId="agentId-label"
            id="agentId"
            name="agentId"
            value={selectedOption}
            input={<OutlinedInput label="Name" />} 
            onChange={(e) => setSelectedOption(e.target.value)}
          >
            { agentData.map(item => (                   
                <MenuItem key={item.id} value={item.id}>
                    {item.name}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </Grid>
        <Grid item xs={12} md={3}>
        <FormControl fullWidth margin="normal" size="small">
          <DatePicker
            label="Pick a Date"
            className={classes.inputField}
            value={nextDate}
            onChange={handleDateChange}
            renderInput={(params) => <TextField type="date" {...params} fullWidth />}
          />
           </FormControl>
        </Grid>
        <Grid item xs={12} md={3}>
      
        <FormControl fullWidth margin="normal">
        <Button onClick={handleSearch} variant="contained" className={classes.button} color="primary" fullWidth >
        Search
            </Button>
            </FormControl>
          
        </Grid>
      </Grid>
    </MuiPickersUtilsProvider>
    </div>
    <Container maxWidth="100%"  style={{backgroundColor:'#020420', padding:'15px 15px 15px' }}>      
    
      <Grid container component={Paper}
      justifyContent="center"        
      color="#94a3b8"
      width="100%"
      alignItems="center"
      style={{height:'calc(100vh - 245px)', padding:'0px', overflow:'hidden', border:'1px solid #324054', margin:'10px 0px 0px 0px',  borderRadius:'8px', backgroundColor:"#0f172a"}}
      className='chatInnerContainer'
      > 
          <Grid item xs={12} justifyContent='center'>
              <List className={classes.messageArea}>
                
                  {
                    
                    messages.map((message, index) => ( 
                      <div>
                          <ListItem className={classes.messRoot}>
                            
                          <Grid style={{width:'100%'}} container className={classes.messContainer}>

                              <Grid item xs={12} alignItems='flex-end'>                                                                     
                                  <ListItemText align="left"  style={{maxWidth:'100%',float:'left'}}  className={classes.textMessage} primary={<span dangerouslySetInnerHTML={{ __html: `${message.question}` }} />} key={message.id}></ListItemText>
                                                            
                              </Grid>
                              <Grid item xs={12} alignItems='flex-end'>
                                  <ListItemText align="left" className={classes.dateTimeText} secondary={message.created_at+' '+message.browser_name+'-('+message.ip_address+')'} key={message.id}></ListItemText>
                                   
                              </Grid>
                             
                              
                          </Grid>
                      </ListItem>
                        
                          <ListItem  >
                            <Grid container style={{width:'100%'}}>
                                <Grid item xs={12} alignItems='flex-start'>                                 
                                    <ListItemText align="left"  style={{maxWidth:'100%'}} className={classes.textMessageLeft} primary={<span dangerouslySetInnerHTML={{ __html: `${message.answer}` }} />} key={message.id}></ListItemText>
                                    
                                </Grid>
                                <Grid item xs={12} alignItems='flex-start'>
                                  {message.status==1?(
                                  <Tooltip title="Like" style={{margin:'-5px 0px 0px -15px',position:'absolute'}}>
                                  <IconButton aria-label="Like" className={classes.copyButton} ><svg stroke="white" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="15" width="15" xmlns="http://www.w3.org/2000/svg"><path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"></path></svg>
                                  </IconButton>
                                    </Tooltip>
                                  ):message.status==2?(
                                  <Tooltip title="Dislike" style={{margin:'-5px 0px 0px -15px',position:'absolute'}}>
                                  <IconButton aria-label="Dislike" className={classes.copyButton} >
                                  <svg stroke="white" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="15" width="15" xmlns="http://www.w3.org/2000/svg"><path d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17"></path></svg>
                                  </IconButton>
                                  </Tooltip>
                                  ):('')}
                              </Grid>
                                <Grid item xs={12} alignItems='flex-start' style={{marginLeft:'20px'}}>
                                    <ListItemText className={classes.dateTimeText} align="left" secondary={message.created_at+' '+message.browser_name+'-('+message.ip_address+')  Visitor Id : '+message.visitor_email+' Visitor Name '+message.visitor_name} key={message.id}></ListItemText>
                                </Grid>
                                
               
                            </Grid>
                            
                        </ListItem>
                        

                 
                  </div>
                 
                 ))
                 } 

     
       

              </List>
              <Divider />
              
          </Grid>
          
      </Grid>
    </Container>
      
    </div>
);
}



export default LiveChatUI;
